var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"4","md":"3","lg":"3","xl":"2"}},[_c('custom-loading',{attrs:{"type":"sidebar"}})],1),_c('v-col',{attrs:{"cols":"12","sm":"8","md":"9","lg":"9","xl":"10"}},[_c('custom-loading',{attrs:{"type":"ck-editor"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }